exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.required-field > label[data-v-f1be3bfe]::after {\n        content: '*';\n        color: red;\n        margin-left: 0.25rem;\n}\n.form-control-feedback[data-v-f1be3bfe] {\n        font-weight: 100;\n        color: red;\n        position: initial;\n        text-align: left;\n        height: auto;\n        width: auto;\n}\n.has-danger[data-v-f1be3bfe] {\n        color: red\n}\n.box-header[data-v-f1be3bfe]{\n  background: #0F6940;\n        color: white\n}\n.gradientbt[data-v-f1be3bfe]{\n  background: #0F6940;\n        color: white\n}\n.box[data-v-f1be3bfe]{\n   box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-f1be3bfe","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/users/UserDetails.vue
// module id = 243
// module chunks = 0